
  export default {
    name: 'main-body',
  };
